<script setup lang="ts">
import { ProductMdw } from '~/lib/services/middleware/middleware.dtos'

const props = defineProps<{
  product: ProductMdw
  categoryTitle: string
  isCombo: boolean
  comboParentCategory?: string
}>()

const { staticProductRoute } = useMcdRoutes()

const buildRoute = () => {
  const categoryTitle =
    props.isCombo && props.comboParentCategory ? props.comboParentCategory : props.categoryTitle
  return staticProductRoute(categoryTitle, props.product.name)
}
</script>

<template>
  <NuxtLink
    class="hover-scale flex cursor-pointer flex-col overflow-hidden rounded-lg shadow-elevation-down"
    :to="buildRoute()"
  >
    <div class="flex h-36 items-end justify-center bg-mcd-secondaryIvory md:h-60">
      <ImageResolver
        :url="product.image"
        :alt="product.name"
        class="mb-6 h-[60%] w-auto object-contain"
        loading="lazy"
      />
    </div>

    <div class="flex flex-col justify-between gap-2 p-3 md:p-4">
      <h2>{{ product.name }}</h2>
    </div>
  </NuxtLink>
</template>
